import $ from "jquery";

const tooltipDirective = (app) => {
  app.directive("tooltip", {
    mounted(el, binding) {
      init(el, binding);
    },
    updated(el, binding) {
      init(el, binding);
    },
  });
};

function init(el, binding) {
  $(el).tooltip('dispose');
  $(el).tooltip();
}

export default tooltipDirective;
